import { render, staticRenderFns } from "./DockActionsMenu.vue?vue&type=template&id=58ac3111&"
import script from "./DockActionsMenu.vue?vue&type=script&lang=js&"
export * from "./DockActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports